export default {
  SET_GROUPS($state, groups) {
    $state.groups = groups.map(g => {
      const existing = $state.groups.find(e => e.id === g.id);
      if (!existing) return g;
      return {
        ...g,
        items: (g.items ?? []).map(incoming => {
          const old = (existing.items ?? []).find(i => i.id === incoming.id);
          return {
            ...incoming,
            checklist_items: incoming.checklist_items?.length
              ? incoming.checklist_items
              : (old?.checklist_items ?? []),
          };
        }),
      };
    });
  },
  ADD_GROUP($state, group) {
    $state.groups.unshift(group);
  },
  UPDATE_GROUP($state, group) {
    const index = $state.groups.findIndex(g => g.id === group.id);
    if (index === -1) return;
    const existing = $state.groups[index];
    const merged = {
      ...group,
      items: (group.items ?? []).map(incoming => {
        const old = (existing.items ?? []).find(i => i.id === incoming.id);
        return {
          ...incoming,
          checklist_items: incoming.checklist_items?.length
            ? incoming.checklist_items
            : (old?.checklist_items ?? []),
        };
      }),
    };
    $state.groups.splice(index, 1, merged);
  },
  DELETE_GROUP($state, id) {
    $state.groups = $state.groups.filter(g => g.id !== id);
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};
